import React from "react";
import { connect } from 'react-redux';
import { useQuery } from "react-query";
import { useQueryClient } from "react-query";

import { fetchSAVFournisseursClients } from 'utils/queries';

import { postSAVFournisseurClient, deleteSAVFournisseurClient } from 'utils/posters';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import CircularProgress from '@mui/material/CircularProgress';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import SkeletonTable from 'components/Shared/SkeletonTable';
import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';
import ClientSearch from 'components/Shared/ClientSearch';

import QualificationTextField from 'components/Shared/QualificationTextField';

const defaultFournisseurClient = {
    fournisseur: { id: 0 },
    client: { id: 0 },
    newNumeroCompte: "",
    creation: false
};

const actionsCellStyle = { wordWrap: "break-word", width: "120px" };

const FournisseursClients = ({ postSAVFournisseurClient, deleteSAVFournisseurClient }) => {


    const [edited, setEdited] = React.useState(defaultFournisseurClient);

    const [saving, setSaving] = React.useState(false);


    const queryClient = useQueryClient();

    const fournisseursClientsQuery = useQuery(["SAVFournisseursClients"], fetchSAVFournisseursClients);



    // Memorisation de la validité du tableau d'ajout de fournisseur
    const liaisonValid = React.useMemo(() => {

        if (edited.creation) {
            if (edited.fournisseur && edited.fournisseur.id !== 0 && edited.client.id !== 0)
            {
                let duplicate = fournisseursClientsQuery.data.fournisseursClients.find(fc => fc.fournisseurId === edited.fournisseur.id && fc.clientId === edited.client.id);

                return !duplicate;
            }
            else {
                return false;
            }
        }

        return edited.newNumeroCompte !== edited.numeroCompte;

    }, [edited.fournisseur, edited.client, edited.creation, edited.newNumeroCompte]);


    

    const post = async () => {
        setSaving(true);

        console.log("validCreation", edited);

        let fournisseurClient = {
            fournisseur: {
                id: edited.fournisseur.id,
                code: edited.fournisseur.code,
                nom: edited.fournisseur.nom,
            },
            client: {
                id: edited.client.id,
                code: edited.client.code,
                nom: edited.client.libelle,
            },
            numeroCompte: edited.newNumeroCompte
        };
        console.log("validCreation", fournisseurClient);

        var result = await postSAVFournisseurClient(fournisseurClient);
        setSaving(false);


        if (result.error) {
            return;
        }

        setEdited(defaultFournisseurClient);
        queryClient.resetQueries("SAVFournisseursClients");
    };


    const handleRemovalFournisseurClient = async (fournisseurClient) => {
        if (fournisseurClient &&
            (fournisseurClient.numeroCompte !== fournisseurClient.newNumeroCompte)) {
            setSaving(true);

            var result = await deleteSAVFournisseurClient(fournisseurClient);

            setSaving(false);

            if (result) {
                queryClient.resetQueries("SAVFournisseursClients"); // Voir pour juste supprimer la ligne
            }
        }

        setEdited(defaultFournisseurClient);
    };


    if (fournisseursClientsQuery.isLoading) {

        let headers = ["Fournisseur", "Client", "Numéro de compte", "Actions"];

        return (
            <SkeletonTable headers={headers} />
        );
    }


    if (fournisseursClientsQuery.error) {
        return (<p>Erreur du chargement des catégories SAV, veuillez contacter le support.</p>);
    }


    if (!fournisseursClientsQuery.data) {
        return null;
    }


    let fournisseursClients = fournisseursClientsQuery.data.fournisseursClients.map(fc => {

        let fournisseur = fournisseursClientsQuery.data.fournisseurs.find(f => f.id === fc.fournisseurId);
        let client = fournisseursClientsQuery.data.clients.find(c => c.id === fc.clientId);
        let fournisseurClient = { numeroCompte: fc.numeroCompte, fournisseur, client };

        return fournisseurClient;
    });

    return (
        <Table size='small'>
            <TableHead sx={{ backgroundColor: 'background.default' }}>
                <TableRow>
                    <TableCell>Fournisseur</TableCell>
                    <TableCell>Client</TableCell>
                    <TableCell>Numéro de compte</TableCell>
                    <TableCell style={actionsCellStyle}>Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <>
                    <TableRow key={-1} hover>

                        {!edited.creation && (
                            <>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                    <Button
                                        size="small"
                                        disabled={edited.numeroCompte !== undefined}
                                        onClick={() => { setEdited({ ...edited, creation: true }); }}
                                        variant={"outlined"}
                                    >
                                        Nouvelle
                                    </Button>
                                </TableCell>
                            </>
                        )}
                        {edited.creation && (
                            <>
                                <TableCell>
                                    <FournisseurGestionAutocomplete
                                        onChange={selection => { setEdited({ ...edited, fournisseur: selection }); }}
                                        autoFocus
                                        required
                                        error={false}
                                        helperText={""}
                                        autoriseSAV
                                    />
                                </TableCell>
                                <TableCell>
                                    <ClientSearch
                                        namespace="administration"
                                        isRequired={true}
                                        onChange={selection => { setEdited({ ...edited, client: selection }); }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <QualificationTextField
                                        label="Numéro de compte"
                                        value={edited.newNumeroCompte}
                                        style={{ paddingBottom: '0px' }}

                                        disabled={saving}

                                        helperText={""}

                                        error={false}
                                        onChange={e => { setEdited({ ...edited, newNumeroCompte: e.target.value }); }}
                                    />
                                </TableCell>
                                <TableCell>


                                    <>

                                        {!saving && (
                                            <>
                                                <IconButton onClick={() => setEdited(defaultFournisseurClient)} color="error"><CancelIcon /></IconButton>
                                                <IconButton onClick={post} color="success" disabled={!liaisonValid}><CheckCircleIcon /></IconButton>
                                            </>
                                        )}

                                        {saving && (<CircularProgress color="secondary" size={16} />)}
                                    </>


                                </TableCell>
                            </>
                        )}

                    </TableRow>
                    {
                        fournisseursClients.map(fc => {

                            let edition = !edited.creation && edited.fournisseur && edited.fournisseur.id === fc.fournisseur.id && edited.client.id === fc.client.id;

                            let showActions = !edited.creation && edited.client.id === 0;

                            return (
                                <TableRow hover sx={showActions ? { "&:hover .MuiTableCell-root:last-child *:first-of-type": { display: 'inherit' } } : {}} key={fc.fournisseur.id + "_" + fc.client.id}>

                                    <TableCell>
                                        {fc.fournisseur.code} - {fc.fournisseur.nom}
                                    </TableCell>
                                    <TableCell>
                                        {fc.client.code} - {fc.client.libelle}
                                    </TableCell>
                                    <TableCell>

                                        {!edition && (
                                            <>{fc.numeroCompte}</>
                                        )}

                                        {edition && (
                                            <QualificationTextField
                                                label="Numéro de compte"
                                                autoFocus
                                                style={{ paddingBottom: '0px' }}
                                                value={edited.newNumeroCompte}

                                                onChange={e => setEdited({ ...edited, newNumeroCompte: e.target.value })}
                                            />
                                        )}
                                    </TableCell>

                                    <TableCell sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                        <Box sx={!edition ? { display: 'none' } : {}}>
                                            {!edition && (
                                                <>
                                                    <IconButton sx={{ paddingTop: '0px', paddingBottom: '0px' }} onClick={() => setEdited({ ...fc, newNumeroCompte: fc.numeroCompte })} disabled={saving} size="small"><EditIcon fontSize="small" /></IconButton>
                                                    <IconButton sx={{ paddingTop: '0px', paddingBottom: '0px' }} onClick={() => handleRemovalFournisseurClient(fc)} disabled={saving} size="small"><DeleteIcon fontSize="small" /></IconButton>
                                                </>
                                            )}

                                            {edition && (

                                                <>

                                                    {!saving && (
                                                        <>
                                                            <IconButton onClick={() => setEdited(defaultFournisseurClient)} color="error"><CancelIcon /></IconButton>
                                                            <IconButton onClick={post} color="success" disabled={!liaisonValid}><CheckCircleIcon /></IconButton>
                                                        </>
                                                    )}

                                                    {saving && (<CircularProgress color="secondary" size={16} />)}
                                                </>

                                            )}


                                        </Box>

                                    </TableCell>
                                </TableRow>
                            );
                        })
                    }


                </>
            </TableBody>
        </Table>
    );

}




const mapDispatchToProps = {
    postSAVFournisseurClient,
    deleteSAVFournisseurClient
};

export default connect(null, mapDispatchToProps)(FournisseursClients);